import LocalizedStrings from 'localized-strings';

import {
  TeamMembersRequestStatus,
  TeamMembersRequestType,
} from '__generated__/GQL';

export default new LocalizedStrings({
  en: {
    [TeamMembersRequestType.ExpenseClaim]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'Pending approval',
        [TeamMembersRequestStatus.Approved]: 'Processing',
        [TeamMembersRequestStatus.Completed]: 'Refunded',
        [TeamMembersRequestStatus.Rejected]: 'Declined',
        [TeamMembersRequestStatus.Canceled]: 'Cancelled',
        [TeamMembersRequestStatus.Processed]: 'Processing',
      },
    },
    [TeamMembersRequestType.BankTransfer]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'Pending approval',
        [TeamMembersRequestStatus.Approved]: 'Processing',
        [TeamMembersRequestStatus.Completed]: 'Executed',
        [TeamMembersRequestStatus.Rejected]: 'Declined',
        [TeamMembersRequestStatus.Canceled]: 'Cancelled',
        [TeamMembersRequestStatus.Processed]: 'Processing',
      },
    },
    [TeamMembersRequestType.VirtualPaymentCardOrder]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'Pending approval',
        [TeamMembersRequestStatus.Approved]: 'Processing',
        [TeamMembersRequestStatus.Completed]: 'Executed',
        [TeamMembersRequestStatus.Rejected]: 'Declined',
        [TeamMembersRequestStatus.Canceled]: 'Cancelled',
        [TeamMembersRequestStatus.Processed]: 'Processing',
      },
    },
    [TeamMembersRequestType.VirtualBudgetCardOrder]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'Pending approval',
        [TeamMembersRequestStatus.Approved]: 'Processing',
        [TeamMembersRequestStatus.Completed]: 'Executed',
        [TeamMembersRequestStatus.Rejected]: 'Declined',
        [TeamMembersRequestStatus.Canceled]: 'Cancelled',
        [TeamMembersRequestStatus.Processed]: 'Processing',
      },
    },
    [TeamMembersRequestType.PhysicalPaymentCardOrder]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'Pending approval',
        [TeamMembersRequestStatus.Approved]: 'Processing',
        [TeamMembersRequestStatus.Completed]: 'Executed',
        [TeamMembersRequestStatus.Rejected]: 'Declined',
        [TeamMembersRequestStatus.Canceled]: 'Cancelled',
        [TeamMembersRequestStatus.Processed]: 'Processing',
      },
    },
  },
  fr: {
    [TeamMembersRequestType.ExpenseClaim]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'En attente de validation',
        [TeamMembersRequestStatus.Approved]: 'En cours de traitement',
        [TeamMembersRequestStatus.Completed]: 'Remboursée',
        [TeamMembersRequestStatus.Rejected]: 'Refusée',
        [TeamMembersRequestStatus.Canceled]: 'Annulée',
        [TeamMembersRequestStatus.Processed]: 'En cours de traitement',
      },
    },
    [TeamMembersRequestType.BankTransfer]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'En attente de validation',
        [TeamMembersRequestStatus.Approved]: 'En cours de traitement',
        [TeamMembersRequestStatus.Completed]: 'Exécuté',
        [TeamMembersRequestStatus.Rejected]: 'Rejeté',
        [TeamMembersRequestStatus.Canceled]: 'Annulé',
        [TeamMembersRequestStatus.Processed]: 'En cours de traitement',
      },
    },
    [TeamMembersRequestType.VirtualPaymentCardOrder]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'En attente de validation',
        [TeamMembersRequestStatus.Approved]: 'En cours de traitement',
        [TeamMembersRequestStatus.Completed]: 'Approuvée',
        [TeamMembersRequestStatus.Rejected]: 'Rejetée',
        [TeamMembersRequestStatus.Canceled]: 'Annulée',
        [TeamMembersRequestStatus.Processed]: 'En cours de traitement',
      },
    },
    [TeamMembersRequestType.VirtualBudgetCardOrder]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'En attente de validation',
        [TeamMembersRequestStatus.Approved]: 'En cours de traitement',
        [TeamMembersRequestStatus.Completed]: 'Approuvée',
        [TeamMembersRequestStatus.Rejected]: 'Rejetée',
        [TeamMembersRequestStatus.Canceled]: 'Annulée',
        [TeamMembersRequestStatus.Processed]: 'En cours de traitement',
      },
    },
    [TeamMembersRequestType.PhysicalPaymentCardOrder]: {
      status: {
        [TeamMembersRequestStatus.Pending]: 'En attente de validation',
        [TeamMembersRequestStatus.Approved]: 'En cours de traitement',
        [TeamMembersRequestStatus.Completed]: 'Approuvée',
        [TeamMembersRequestStatus.Rejected]: 'Rejetée',
        [TeamMembersRequestStatus.Canceled]: 'Annulée',
        [TeamMembersRequestStatus.Processed]: 'En cours de traitement',
      },
    },
  },
} as const);
